import { render, staticRenderFns } from "./CallTile.vue?vue&type=template&id=55301198&scoped=true"
import script from "./CallTile.vue?vue&type=script&lang=js"
export * from "./CallTile.vue?vue&type=script&lang=js"
import style0 from "./CallTile.vue?vue&type=style&index=0&id=55301198&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55301198",
  null
  
)

export default component.exports